module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan2-2-890e670ddbb1fb26b02e03315f2dce40.webp";